import { createSlice } from '@reduxjs/toolkit'
export const shipmentMovementsSlice = createSlice({
  name: 'shipmentMovements',
  initialState: {
    isRefreshShipmentMovementGridData: false
  },
  reducers: {
    refreshShipmentMovementGridData: (state, action) => {
      state.isRefreshShipmentMovementGridData = action.payload;
      return state;
    },
  }
})
export const { refreshShipmentMovementGridData } = shipmentMovementsSlice.actions
export default shipmentMovementsSlice.reducer 
